import Subscribe from './Subscribe';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

Subscribe.schema = schema;
Subscribe.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default Subscribe;
